import axios from 'axios';
import Cookies from 'universal-cookie';


const baseURL="https://ethiopianpassportapiu.ethiopianairlines.com";
// const baseURL="https://passport-client-api-preprod.azurewebsites.net";

const cookies = new Cookies();


const getTokenForRefresh = () => {

    // axios({
    //     method: 'post',
    //     url:
    //         'https://ethiopianpassportapiu.ethiopianairlines.com/User/api/V1.0/Account/SignIn',
    //     data: {
    //         username: 'Anonymous@ethiopianairlines.com',
    //         password: 'hT3#w9kLp@GdmZ7Xq!872Ws',
    //     },
    // })
    //     .then(async (response) => {
    //         ;
    //         cookies.remove('SY_TO');
    //         cookies.remove('RF_TO');
    //         await cookies.set('SY_TO', response.data.accessToken);
    //         cookies.set('RF_TO', response.data.refreshToken);
    //         // window.location.reload();
    //     })
    //     .catch((error) => {
    //         console.log(error);
    //     })
    cookies.remove("U_AC_TO");
    cookies.remove("U_REF_TO");
    localStorage.removeItem("customerData");
    localStorage.removeItem("session_start");
    window.location.href = '/signin'; 
}


const tokenValue = () => {


    let UserToken = cookies.get('U_AC_TO');
    let SystemToken = cookies.get('U_AC_TO');
    if (UserToken) {
        return UserToken;
    }
    else if (SystemToken) {
        return SystemToken;
    }
    else {
        SystemToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJKV1RfQ1VSUkVOVF9VU0VSIjoiQW5vbnltb3VzQGV0aGlvcGlhbmFpcmxpbmVzLmNvbSIsIm5iZiI6MTczMjA4MjQzNSwiZXhwIjoxNzQyNDUwNDM1LCJpYXQiOjE3MzIwODI0MzV9.9trNDDeFAMR6ByGB5Hhv8k5Q-16RGpPuGKmCpw95niY';
        return SystemToken;
    }
};
const token = tokenValue();
const getAuthentication = () => {

    let headers = {};
    const token = tokenValue();
    if (token && typeof (token) !== 'undefined') {
        headers.Authorization = `Bearer ${token}`;
    }
    return {
        headers
    };
}

const UserToken = cookies.get('U_AC_TO');

const axiosInstance = axios.create({

    baseURL: baseURL,
    //headers:getAuthentication(),

    headers: {
        Authorization: UserToken ? `Bearer ${token}` : `Bearer ${token}`,
        "Access-Control-Allow-Credentials": true
    }
});
axiosInstance.interceptors.response.use(

    (response) =>
        new Promise((resolve, reject) => {

            resolve(response);
        }),
    (error) => {

        if (!error.response) {
            return new Promise((resolve, reject) => {
                reject(error);
            })
        }
        if (error.response.status === 401) {
            ;
            getTokenForRefresh();
        } else {
            return new Promise((resolve, reject) => {
                reject(error);
            })
        }
    }
)


export default axiosInstance;